define('appkit/service.util',['require','exports','module','underscore','backbone.radio'],function(require, exports, module) {
  var _ = require('underscore');
  var Radio = require('backbone.radio');

  function REQUIRED_OPTION() {};

  var ServiceUtil = {

    REQUIRED_OPTION: new REQUIRED_OPTION(),

    mergeRadioOptions: function(service, configurationChannel) {
      configurationChannel = configurationChannel || _.result(service, 'configurationChannelName');

      if (_.isString(configurationChannel)) {
        configurationChannel = Radio.channel(configurationChannel);
      }

      var options = _.extend(
        {},
        _.result(service, 'options'),
        (configurationChannel instanceof Radio.Channel) ? configurationChannel.request('options', service) : {}
      );

      _.each(options, function(value, key) {
        if (value === ServiceUtil.REQUIRED_OPTION) {
          throw new Error(
            'Missing required option "' + 
            key +
            '" from the service configuration "' +
            _.result(configurationChannel, 'channelName') + '"');
        }
      });

      service.options = options;
      return options;
    }

  };

  module.exports = ServiceUtil;
});
